
import { Component } from "vue-property-decorator"
import Preview from "./Preview.vue"

@Component({
  components: { Preview },
})
export default class PcPreview extends Preview {
  public created(): void {
    const type = "pc"
    const message = "こちらにアクセス"

    this.postPreview(type, message)
  }
}
